export const DIETARY_PREFERENCES_MAP = {
  gourmet: 'No dietary preference',
  vegetarian: 'Vegetarian'
}

export const BOX_SIZES = ['2', '4']

export const MEALS_PER_BOX_MAP = {
  2: '2',
  3: '3',
  4: '4'
}

export const MEALS_PER_BOX_MAP_5R = {
  2: '2',
  3: '3',
  4: '4',
  5: '5'
}
